/**
 * @Author ZhangYing
 * @Date 2022-11-15 21:14:32
 * @LastEditors ZhangYing
 * @LastEditTime 2022-11-15 22:28:29
 * @Description
 * @FilePath /BM-Main/src/utils/login.js
 * @props
 */
import native from '@zz-common/native-adapter'
import { url } from '@zz-common/zz-utils'
import { isGaodeSilentLoginScene } from '@/utils/bmFromScene';
import { gaodeLoginAjax } from '@/apiData/gaode';
/**
 * adapter判断登陆状态有isLogin和isLoginAsync两种方法，
 * 其中
 * isLogin只判断cookie中是否包含PPU和ZZU(58)
 * isLoginAsync会判断
 *  第一：用户登录了58app
 *  第二：用户登录了转转
 *  第三：转转登录信息是通过58授权得来的
 * isLoginAsync是异步方法，需要通过回调获得登陆状态
 * @returns {Promise<unknown>}
 */
export default function(params = {}) {
  // 高德静默登录，暂时每次登录判断都调，怕登录过期，不触发ppu更新，后续量大再考虑优化
  // 在高德内，BM_8899渠道号走h5 手机号验证码登录，BM_1866，走静默登录，原因：两个团队，BM_8899没有研发支持，啊这。。。
  if (isGaodeSilentLoginScene) {
    const { appId, userInfo } = url.getParams() || {}
    return gaodeLoginAjax({ param: JSON.stringify({ appId, userInfo, source: 186 }) })
  }
  return new Promise((resolve, reject) => {
    native.isLoginAsync({
      callback: (isLogin) => {
        console.log('isLogin: ', isLogin);
        if (isLogin) {
          resolve(true)
        } else {
          // 广告进入的需要跳过绑定手机号步骤
          const { clickid } = url.getParams() || {}
          native.login({
            ...params,
            skipBindPhone: clickid ? 1 : 0,
            callback: (json) => {
              console.log('json: ', json);
              if (parseInt(json.code) === 0) {
                resolve(true)
              } else {
                if (reject) {
                  reject(new Error('请登录'))
                }
              }
            }
          })
        }
      }
    })
  })
}

export const loginPromise = (params) => {
  return new Promise((resolve, reject) => {
    native.login({
      ...params,
      callback: (json) => {
        console.log('json: ', json);
        if (parseInt(json.code) === 0) {
          resolve(true)
        } else {
          reject(new Error('请登录'))
        }
      }
    })
  })
}
